export default __webpack_public_path__ + "static/nightfall-5fe78432a1a4245fdf24bfadef336ec4.png";